import React from "react";
import SingleAircraftContent from "../components/aircrafts/single-aircraft-content";

const SingleAircraft = () => {
  return <SingleAircraftContent />;
};

export default SingleAircraft;
